import { ComponentProps } from "react";
import styled from "@emotion/styled";
import { images } from "@financial-advisory/ui/illustrations";
import { UserIcon } from "@heroicons/react/24/solid";
import { Icon } from "@unlikelyai-magic/ui/icons";

type ChatAvatarProps = ComponentProps<"img"> & {
  visible?: boolean;
};

export const UserAvatar = styled(({ visible, ...props }: ChatAvatarProps) => (
  <img {...props} src={images.userAvatar} alt="User Avatar" />
))`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
  object-fit: cover;
`;
